module.exports = __webpack_public_path__ + "static/media/homecare_icon.d9acd3ac.png";